export default {
  alert: {
    updated_successfully: 'Billing update successfully',
  },
};
